import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

export interface MetadataI {
  page: number,
  page_size: number,
  total_items: number,
  total_pages: number
}

export interface IGetMasterVendorsData {
  id: number,
  vendor_code: string,
  vendor_name: string,
  vendor_address: string,
  type_vendor: string,
  bank_key: string,
  bank_account: string,
  bank_name: string,
  bank_account_number: string,
  bank_account_name: string,
  status_vendor: string,
  status_approval: string,
  create_at: string,
  pool_department: {
    vendor_code: string,
    pool_id: string,
    department: string
  }[],
  vendor_files: {
    id: number,
    trx_id: string,
    item_id: number,
    file_name: string,
    path_file: string,
    source_file: string,
    source_key: string,
    file_size: string,
    create_at: string,
    create_by: string
  }[],
  approvals: {
    id: number,
    trx_id: string,
    approval_code: string,
    approval_number: number,
    department: string,
    job_id: number,
    job_title: string,
    job_flow: string,
    employee_id: string,
    employee_name: string,
    employee_email: string,
    status_approval: string,
    reason_status: string,
    status_bon: string,
    approval_start: string,
    approval_end: string,
    create_at: string,
    create_by: string,
    update_at: string,
    update_by: string
  }[],
  flag_column: string,
  flag_column_desc: string
}
export interface IGetMasterVendorsResponse {
  list_mst_vendor: IGetMasterVendorsData[];
  metadata: MetadataI
}
export interface IGetMasterVendorsPayload {
  search?: string,
  status_vendor?: string,
  status_approval?: string,
  pool_id?: string,
  department?: string,
  employee_email: string,
  sort_by?: string,
  sort_type?: string,
  page_number: number,
  page_size?: number,
}

export const url = "/v1/smplmstvendor";

export const getMasterVendors = async (
  payload: IGetMasterVendorsPayload,
): Promise<IGetMasterVendorsResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "GET",
    params: payload,
  });

  return data;
};

interface IPostMasterVendorResponse {
  responseCode: string,
  responseMessage: string
}

interface IPostMasterVendorsPayload {
  vendor_name: string,
  vendor_address: string,
  type_vendor: string,
  client_name: string,
  bank_account: string,
  bank_name: string,
  bank_account_number: string,
  bank_account_name: string,
  code_type: string,
  area_id: string,
  pool_id: string,
  create_by: string,
  lst_assignments: {
    pool_id: string,
    department: string
  }[],
  lst_vendor_file: {
    item_id: number,
    file_name: string,
    file_base64: string,
    file_size: string,
    create_by: string
  }[]
}

export const postMasterVendors = async (
  payload: IPostMasterVendorsPayload,
): Promise<IPostMasterVendorResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "POST",
    data: payload,
  });

  return data;
};

interface IPutMasterVendorPayload {
  vendor_code: string,
  status_vendor: string,

  vendor_name: string,
  vendor_address: string,
  type_vendor: string,
  client_name: string,
  bank_account: string,
  bank_name: string,
  bank_account_number: string,
  bank_account_name: string,
  code_type: string,
  area_id: string,
  pool_id: string,
  create_by: string,
  lst_assignments: {
    pool_id: string,
    department: string
  }[]
}

export const putMasterVendor = async (
  payload: IPutMasterVendorPayload,
): Promise<IPostMasterVendorResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "PUT",
    data: payload,
  });

  return data;
};

export interface IGetMasterVendorDetailResponse {
  id: number,
  vendor_code: string,
  vendor_name: string,
  vendor_address: string,
  type_vendor: string,
  bank_key: string,
  bank_account: string,
  bank_name: string,
  bank_account_number: string,
  bank_account_name: string,
  status_vendor: string,
  status_approval: string,
  create_at: string,
  pool_department: {
    vendor_code: string,
    pool_id: string,
    pool_name: string,
    department: string,
    code_type: string,
    area_id: string,
    area_desc: string,
  }[],
  vendor_files: {
    id: number,
    trx_id: string,
    item_id: number,
    file_name: string,
    path_file: string,
    source_file: string,
    source_key: string,
    file_size: string,
    create_at: string,
    create_by: string
  }[],
  approvals: {
    id: number,
    trx_id: string,
    approval_code: string,
    approval_number: number,
    department: string,
    job_id: number,
    job_title: string,
    job_flow: string,
    employee_id: string,
    employee_name: string,
    employee_email: string,
    status_approval: string,
    reason_status: string,
    status_bon: string,
    approval_start: string,
    approval_end: string,
    create_at: string,
    create_by: string,
    update_at: string,
    update_by: string
  }[],
  flag_column: string,
  flag_column_desc: string
}

export const getMasterVendorDetail = async (
  vendorCode: string,
): Promise<IGetMasterVendorDetailResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/vendorcode/${vendorCode}`,
    method: "GET",
  });

  return data;
};
